export default __webpack_public_path__ + "static/media/star.facb9b36.svg";